var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomepageClock = function SvgHomepageClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.69 18.12",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.85.1C3.61.1 0 3.81 0 9.06s3.6 8.96 8.85 8.96 8.84-3.71 8.84-8.96S14.09.1 8.85.1m0 16c-4.14 0-6.93-2.83-6.93-7.04S4.7 2.02 8.85 2.02s6.91 2.83 6.91 7.04-2.78 7.04-6.91 7.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.48 4.5H7.56v5.26l3.19 3.2 1.37-1.36-2.64-2.64z"
  })));
};
export default SvgHomepageClock;